import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;

export const modalCss = {
  root: {
    zIndex: 20,
  },
  modalContentWrapper: {
    height: "100",
    [mq.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      height: "auto",
      maxWidth: "800px",
    },
  },
  footer: {
    marginTop: "auto",
  },
};

export const modalBodyWrapperCss = {
  "> * + *": {
    marginTop: 24,
  },
};

export const lmsProvidersWrapper = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px 0",
  "> *": {
    flexShrink: 0,
    height: "100%",
    objectFit: "contain",
  },
  "> * + *": {
    marginLeft: 24,
  },
  [mq.downTo(constants.breakpoints.BreakpointNames.xs)]: {
    height: 145,
    padding: "20px 0",
    "> * + *": {
      marginLeft: 60,
    },
  },
};

export const googleIconCss = {
  width: 100,
  [mq.downTo(constants.breakpoints.BreakpointNames.xs)]: {
    width: "fit-content",
  },
};

export const canvasIconCss = {
  width: 84,
  [mq.downTo(constants.breakpoints.BreakpointNames.xs)]: {
    width: "fit-content",
  },
};

export const modalFooterWrapperCss = {
  display: "flex",
};

export const modalFooterButtonCss = {
  root: {
    marginLeft: "auto",
    [mq.upTo(constants.breakpoints.BreakpointNames.xs)]: {
      marginLeft: 0,
      width: "100%",
      justifyContent: "center",
    },
  },
};

export const spanTextCss = {
  [mq.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    width: "100%",
  },
};

export const syncButtonCss = {
  root: {
    [mq.upTo(constants.breakpoints.BreakpointNames.sm)]: {
      display: "block",
      padding: "8px 32px",
      marginTop: 8,
      width: "100%",
    },
  },
};
